import React from 'react'

const Header = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <header className="premium-header shadow-lg sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between px-6 py-4 relative">
        {/* Logo Section */}
        <div className="flex items-center ml-4 md:ml-0">
          <div className="flex-shrink-0">
            <img
              src="/assets/images/logo.png"
              alt="AuraSquare Events Logo - Premier Event Management in Tamil Nadu"
              className="h-16 w-auto object-contain filter drop-shadow-lg"
            />
          </div>
        </div>

        {/* Navigation Links */}
        <nav className="hidden md:flex items-center space-x-8">
          <a
            href="#services"
            className="text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base relative group"
          >
            Services
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#1abc9c] to-[#16a085] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <a
            href="#decorations"
            className="text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base relative group"
          >
            Decorations
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#1abc9c] to-[#16a085] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <a
            href="#entertainment"
            className="text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base relative group"
          >
            Entertainment
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#1abc9c] to-[#16a085] transition-all duration-300 group-hover:w-full"></span>
          </a>
          <a
            href="#photobooths"
            className="text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base relative group"
          >
            Photobooths
            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#1abc9c] to-[#16a085] transition-all duration-300 group-hover:w-full"></span>
          </a>
        </nav>

        {/* Contact Button */}
        <div className="hidden md:flex items-center">
          <a
            href="https://wa.me/919444848616"
            className="premium-btn text-sm font-semibold"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-whatsapp text-lg"></i>
            <span>WhatsApp Us</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden absolute right-6">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-700 hover:text-[#1abc9c] focus:outline-none focus:ring-2 focus:ring-[#1abc9c] p-2 rounded-lg"
            aria-label="Toggle mobile menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden border-t border-gray-100 ${mobileMenuOpen ? '' : 'hidden'}`}>
        <div className="px-6 py-4 space-y-3">
          <a
            href="#services"
            className="block text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base py-3"
          >
            Services
          </a>
          <a
            href="#decorations"
            className="block text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base py-3"
          >
            Decorations
          </a>
          <a
            href="#entertainment"
            className="block text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base py-3"
          >
            Entertainment
          </a>
          <a
            href="#photobooths"
            className="block text-gray-700 hover:text-[#1abc9c] font-semibold transition duration-300 text-base py-3"
          >
            Photobooths
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
